import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { refreshToken } from '@/api/user'
import ElementUI from 'element-ui'  // 导入Element UI
import 'element-ui/lib/theme-chalk/index.css'  // 导入Element UI样式
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(ElementUI)  // 使用Element UI
Vue.use(mavonEditor)

Vue.config.productionTip = false

// 生产环境：同源部署用 /api（由 Nginx 反向代理到后端）；跨域部署在 .env.production 或构建时设置 VUE_APP_BASE_URL
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || '/api'
axios.defaults.withCredentials = true

// 无感刷新：避免并发 401 时重复调用刷新接口
let refreshingPromise = null

function clearAuthAndRedirect() {
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('userName')
  refreshingPromise = null
  if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/') {
    router.push('/login')
  }
}

// 请求拦截器：携带 accessToken，业务请求同时携带 Refresh-Token 便于服务端无感刷新
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    const refresh = localStorage.getItem('refreshToken')
    const isAuthUrl = config.url && (config.url.includes('/user/login') || config.url.includes('/user/refresh'))
    if (refresh && !isAuthUrl) {
      config.headers['Refresh-Token'] = refresh
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器：处理服务端通过响应头下发的的新 token，以及 401 时尝试刷新后重试
axios.interceptors.response.use(
  response => {
    const newAccess = response.headers['x-new-access-token']
    const newRefresh = response.headers['x-new-refresh-token']
    if (newAccess) {
      localStorage.setItem('token', newAccess)
      if (newRefresh) localStorage.setItem('refreshToken', newRefresh)
    }
    return response
  },
  async error => {
    const originalRequest = error.config
    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error)
    }
    // 若是刷新接口本身 401，直接清空并跳转登录
    if (originalRequest.url && originalRequest.url.includes('/user/refresh')) {
      clearAuthAndRedirect()
      return Promise.reject(error)
    }
    const refresh = localStorage.getItem('refreshToken')
    if (!refresh) {
      clearAuthAndRedirect()
      return Promise.reject(error)
    }
    // 避免重复刷新：若已在刷新则等待同一 promise
    if (!refreshingPromise) {
      refreshingPromise = refreshToken(refresh)
        .then(res => {
          const data = res.data && res.data.data
          if (data && data.token) {
            localStorage.setItem('token', data.token)
            if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken)
            if (data.userName) localStorage.setItem('userName', data.userName)
          }
          return data
        })
        .catch(() => null)
        .finally(() => { refreshingPromise = null })
    }
    const newTokens = await refreshingPromise
    if (!newTokens || !newTokens.token) {
      clearAuthAndRedirect()
      return Promise.reject(error)
    }
    originalRequest.headers.Authorization = `Bearer ${newTokens.token}`
    return axios(originalRequest)
  }
)

// 3. 将axios挂载到Vue原型
Vue.prototype.$axios = axios

// 4. 最后创建Vue实例
new Vue({
  router,  // 注册路由
  render: h => h(App),
}).$mount('#app')